import { FC } from 'react';

import Button from '../../buttons/Button';
import { TextField } from '../fields';

import { ApplyCouponWrapper } from './Wrapper';

export type ApplyCouponProps = { onApply(): void };

const ApplyCoupon: FC<ApplyCouponProps> = ({ onApply }) => (
  <ApplyCouponWrapper>
    <TextField
      name="coupon"
      type="text"
      label="Coupon Code"
      labelVariant="static-above-dark-uppercase"
      inputVariant="simple-small"
    />
    <Button
      type="submit"
      variant="white-text-field"
      size="medium"
      onClick={onApply}
    >
      Apply
    </Button>
  </ApplyCouponWrapper>
);

export default ApplyCoupon;
